import * as actionTypes from '../actions/actionTypes';

const initialState = {
  modalType: null,
  modalProps: {
    open: false
  }
}

const reducer = (state=initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MODAL:
      return {
        modalProps: action.modalProps,
        modalType: action.modalType
      }
    case actionTypes.HIDE_MODAL:
      return initialState
    default:
      return state
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/modals.js